// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-288f8192] .button-ellipsis.dx-button {\n  min-width: 0;\n  min-height: 0;\n  height: unset;\n  display: flex;\n}\n[data-v-288f8192] .button-ellipsis.dx-button .dx-button-content {\n  padding: 0;\n  min-width: 0;\n  min-height: 0;\n}\n[data-v-288f8192] .button-ellipsis.dx-button .dx-icon {\n  width: 20px;\n  height: 20px;\n  min-width: 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
